import { Tag } from '@design-system/components/tag/tag';
import { LiteCollection } from '../collections.domain';

export const CollectionTag = ({ type }: Pick<LiteCollection, 'type'>) => {
  switch (type) {
    case 'draft':
      return <Tag label="Draft" className="bg-[#F5E5D2]" readonly />;
    case 'published':
      return <Tag label="Published" className="bg-[#C8EFCF]" readonly />;
    case 'archived':
      return <Tag label="Archived" className="bg-[#EEEEEE]" readonly />;
  }
};
